import React, { useEffect, useRef } from "react";
import { handleDecodeURL } from "../../utils";

export default function PayGate(props) {
  const formRef = useRef(null);
  const searchParams = props.searchParams;
  const action = props.action;

  useEffect(() => {
    formRef.current.submit();
  }, []);
  return (
    <form ref={formRef} method="GET" action={handleDecodeURL(action)}>
      {[...searchParams.entries()].map(([key, value]) => {
        if (key === "action" || key === "gateway" || key === "redirect") return null;
        return (
          <input
            type="hidden"
            name={key}
            key={key}
            value={handleDecodeURL(value)}
          />
        );
      })}
    </form>
  );
}
